import React from 'react';
import {
  FDAvatar, FDPaper,
  FDPrimaryActionButton,
  FDSecondaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import RecommendedPlannerInfo
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingPlannerAssignmentRecommendedPlanner/RecommendedPlannerInfo';

function PlannerOptionCard({ plannerOptionResource, onSubmit }) {
  const { setOnboardingStepCollection } = useSurveyContext();
  const profileImageRel = plannerOptionResource.withRelationship(fr.relationships.profileImage.name, (rel) => rel, () => null);
  const biographyRel = plannerOptionResource.withRelationship(fr.relationships.biography.name, (rel) => rel, () => null);
  const [loading, setLoading] = React.useState(false);
  const { displayErrorMessage } = useSnackbarContext();
  const isMobile = useMobileLayout();

  const handleSelectOption = async () => {
    try {
      setLoading(true);
      plannerOptionResource.attr('isSelected', 'true');
      const resp = await onSubmit();
      setOnboardingStepCollection(resp);
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to select options');
    } finally {
      setLoading(false);
    }
  };

  return (
    <FDPaper appearance={'outlined'} padding={2} width={isMobile ? '100%' : '315px'}>
      <FDStack direction={'column'} spacing={3} justifyContent={'center'} alignItems={'center'}>
        <FDAvatar
          size={'xl'}
          alt={profileImageRel?.meta('altText')}
          src={profileImageRel?.link('related').url()}
        />
        <RecommendedPlannerInfo resource={plannerOptionResource} />
        <FDStack direction={'column'} spacing={2} width={'100%'}>
          <FDPrimaryActionButton label={plannerOptionResource.attr('selectText')} onClick={handleSelectOption} loading={loading} disabled={loading} isFullWidth />
          { biographyRel ? <FDSecondaryActionButton label={biographyRel.meta('prompt')} href={biographyRel.link('related').url()} disabled={loading} isFullWidth /> : null }
        </FDStack>
      </FDStack>
    </FDPaper>
  );
}

export default PlannerOptionCard;
